import { GetServerSidePropsContext, NextPageContext } from 'next';
import { getServerCookie } from '../utils/CookieUtils';
import { COOKIE } from './constants';
import Cookies from 'universal-cookie';

type User = { id?: string } | null | undefined;

export const getRecommendationId = (
  ctx?: NextPageContext | GetServerSidePropsContext,
  user?: User,
): string | undefined => {
  if (!ctx) {
    const cookies = new Cookies();
    // TODO: Remove this legacy recommended user 400 days after it is deployed (that's the max time a cookie can be stored in the browser)
    // See https://distilledsch.tpondemand.com/entity/114667-remove-fallback-on-legacy-ddrecommendeduser
    const legacyRecommendedUser = cookies.get(
      COOKIE.DD_LEGACY_RECOMMENDED_USER,
    );
    const clientID = cookies.get(COOKIE.DD_CLIENT_ID);
    return user?.id ?? legacyRecommendedUser ?? clientID;
  }

  // TODO: Remove this legacy recommended user 400 days after it is deployed (that's the max time a cookie can be stored in the browser)
  // See https://distilledsch.tpondemand.com/entity/114667-remove-fallback-on-legacy-ddrecommendeduser
  const legacyRecommendedUser = getServerCookie(
    COOKIE.DD_LEGACY_RECOMMENDED_USER,
    ctx,
    true,
  ) as string | undefined;
  const clientID = getServerCookie(COOKIE.DD_CLIENT_ID, ctx, true) as
    | string
    | undefined;
  return user?.id ?? legacyRecommendedUser ?? clientID;
};
